import http, { createApi } from '@core/fetch'
export default {
  // 获取商家发布信息(判断商家是否违规)
  getMercantPublicInfo: createApi(
    '/hms/hljComplaint/adminApi/proof/merchant/info'
  ),
  // 获取标签数据
  getMealMarks: params =>
    http.get('/p/wedding/index.php/admin/APISetMeal/mealMarks', {
      body: params
    }),
  // 编辑/新增案例
  editCase: params =>
    http.post(`/hms/hljLocalserviceProduct/adminApi/setMeal/editCase`, {
      body: params,
      ignore: [null, undefined]
    }),
  // 保存草稿
  saveDraft: body =>
    http.post('/hms/merchant/appApi/draftCase/edit', {
      body
    }),
  // 获取案例详情
  getCase: createApi('/hms/hljLocalserviceProduct/adminApi/setMeal/info'),
  // 获取草稿详情
  getDraftDetail: body =>
    http('/hms/merchant/appApi/draftCase/detail', {
      body
    }),
  // 删除草稿
  delDraft: body =>
    http.post('/hms/merchant/appApi/draftCase/delete', {
      body,

      onError: false
    }),
  // 删除案例
  deleteSetMeal: params =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/delete', {
      body: params,
      onError: false
    }),
  // 案例名称敏感词检查
  checkWord: body =>
    http.post('/hps/admin/localServerMerchant/index/setMealSensitiveWord', {
      body,
      ignore: []
    })
}
